import React from 'react';
import { Modal } from 'zarm';
import classnames from 'classnames';

import componentConfig from './componentConfig';
import { IWidgetItemProps, IWidgetItem } from './type';

const HealthItem = (props: IWidgetItemProps) => {
  const { _crengine, healthChildrens, maxLength, readonly, onAddBtn, onDeleteBtn } = props;
  const { form } = _crengine || {};

  // 增加删除弹框
  const handleDeleteModal = (index: number) => {
    Modal.confirm({
      content: '确认删除？',
      onOk: () => {
        onDeleteBtn(index);
      },
    });
  };

  const renderChild = (options: IWidgetItem[], formFieldIndex: number) => {
    if (!(options && Array.isArray(options) && options.length)) {
      return;
    }

    return options.map((item) => {
      const { widget } = item;

      const Components = componentConfig[widget] ? componentConfig[widget] : null;

      if (item.wprops) {
        item = Object.assign(item, item.wprops);
        delete item.wprops;
      }

      const assignObj = { ..._crengine, ...item };

      if (assignObj.dataBind) {
        // tips：通过panel包裹后，会自动加path,最终路径为 a.0.c，a.1.c
        assignObj.dataBind = `${formFieldIndex}.${assignObj.dataBind}`;
      }

      if (Components) {
        return <Components key={`${item.dataBind}-${formFieldIndex}`} {...item} form={form} _crengine={assignObj} />;
      }
      return null;
    });
  };

  const renderAddBtn = () => {
    if (readonly) {
      return null;
    }
    const addBtnComp = (
      <div className="health-item-widget-add" onClick={onAddBtn}>
        <i className="icon-add" />
        新增
      </div>
    );
    if (maxLength) {
      if (healthChildrens.length < maxLength) {
        return addBtnComp;
      }
      return null;
    }
    return addBtnComp;
  };

  const renderDeleteBtn = (clsDelete, index) => {
    if (readonly) {
      return null;
    }
    if (healthChildrens.length > 1) {
      return (
        <div className={clsDelete}>
          <span className="radio-health__title-delete-icon" onClick={() => handleDeleteModal(index)} />
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      {(healthChildrens || []).map((item, index) => {
        const {
          props: { title, options },
          formFieldIndex,
        } = item;

        const clsDelete = classnames({
          'radio-health__title-delete': true,
          'radio-health__title-haveTitle': !!title,
        });

        return (
          <div key={formFieldIndex} className="health-item-widget">
            <div className="radio-health__title">
              {title && <div className="radio-health__title-name">{title}</div>}
              {renderDeleteBtn(clsDelete, index)}
            </div>
            {renderChild(options, formFieldIndex)}
          </div>
        );
      })}
      {renderAddBtn()}
    </div>
  );
};

export default HealthItem;
